import * as React from 'react';
import PropTypes from 'prop-types';

import startupConfig from '../../config/startupConfig';
import SnackbarAlert from '../core/SnackbarAlert';

const StartupConfig = ({ configuration, isConfigurationSet, getStartupConfig }) => {
  const [stateGetStartupConfigErrored, setGetStartupConfigErrored] = React.useState(null);

  React.useEffect(() => {
    if (isConfigurationSet) {
      startupConfig.set(configuration);
    } else {
      getStartupConfig().then((actionSuccess) => {
        setGetStartupConfigErrored(actionSuccess === false);
      });
    }
  }, [isConfigurationSet, configuration, getStartupConfig]);

  if (stateGetStartupConfigErrored === true) {
    return (
      <SnackbarAlert
        message="Error initializing"
        variant="error"
        horizontalPosition="right"
        verticalPosition="top"
      />
    );
  }

  return null;
};

StartupConfig.propTypes = {
  configuration: PropTypes.object,
  isConfigurationSet: PropTypes.bool,
  getStartupConfig: PropTypes.func.isRequired,
};

StartupConfig.defaultProps = {
  configuration: null,
  isConfigurationSet: false,
};

export default StartupConfig;
